module.exports = __webpack_public_path__ + "img/position_CM.fa6d6016.png";